import React from 'react';
import { motion } from 'framer-motion';
import { scrollToSection } from '../scrollUtils';

const Hero = ({ id = "hero" }) => {
  return (
    <section id={id} className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Moveable Static Background Image (Ken Burns Effect) */}
      <div className="absolute inset-0 w-full h-full z-0 overflow-hidden">
        <motion.div
          initial={{ scale: 1.15, x: "-2%" }}
          animate={{
            scale: [1.15, 1.05, 1.15],
            x: ["-2%", "2%", "-2%"],
            y: ["-1%", "1%", "-1%"]
          }}
          transition={{
            duration: 20,
            repeat: Infinity,
            ease: "linear"
          }}
          className="absolute inset-0 w-full h-full hero-bg-container"
          style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=2070&auto=format&fit=crop')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        />

        {/* Subtle Dark Overlay (30% Opacity) */}
        <div className="absolute inset-0 bg-black/30 z-10"></div>

        {/* Additional Gradient for Depth and Readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-transparent to-black/80 z-10"></div>
      </div>

      {/* Content */}
      <div className="relative z-20 text-center text-white px-4 max-w-6xl mx-auto hero-content">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.2 }}
          className="text-lg xs:text-xl sm:text-2xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight sm:whitespace-nowrap"
        >
          Crafting{' '}
          <motion.span
            className="inline-block"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.2 }}
          >
            <span className="text-yellow-400">Dream</span>
          </motion.span>{' '}
          Interiors
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.2 }}
          className="text-lg sm:text-xl md:text-2xl mb-8 sm:mb-10 max-w-3xl mx-auto leading-relaxed px-4"
        >
          Transforming spaces with innovative design and exceptional craftsmanship
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.2 }}
        >
          <button
            onClick={() => scrollToSection('projects')}
            className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 sm:py-4 px-6 sm:px-8 rounded-full text-base sm:text-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl h-14 sm:h-16 min-w-[160px] sm:min-w-[200px]"
          >
            Explore Our Work
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
